import * as angular from 'angular';

export class CategoriesFactory {
    private apiRoot: string = '/api/v1/companies';
    private $http;

    constructor($http) {
        this.$http = $http;
    }

    get(companyId: string, params: any) {
        return this.$http.get(
            `${this.apiRoot}/${companyId}/categories/`,
            { params }
        );
    }
}

angular
    .module('app')
    .service('CategoriesFactory', CategoriesFactory);



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/services/categories.factory.ts